import { booleanAttribute, ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import { IconButtonComponent } from '../button/icon-button.component';
import { IconComponent } from '../icon/icon.component';
import { Search, X } from '../icon/icons';

let nextId = 0;

/**
 * Buscador en píldora. `label` es una `<label>` oculta, no `aria-label`: el diseño sólo muestra el
 * placeholder, que no sirve de nombre, y el WebView de Android descarta `aria-label` en algunos controles.
 * `active` da el borde del campo que manda en la pantalla.
 */
@Component({
  selector: 'ui-search-field',
  imports: [IconButtonComponent, IconComponent],
  template: `
    <label class="ui-visually-hidden" [attr.for]="inputId">{{ label() }}</label>
    <div class="pill" [class.active]="active()">
      <ui-icon class="search" [icon]="searchIcon" size="1.125rem" />
      <input
        class="input"
        [id]="inputId"
        type="search"
        enterkeyhint="search"
        [value]="value()"
        [attr.placeholder]="placeholder() ?? null"
        (input)="onInput($event)"
      />
      @if (value()) {
        <button uiIconButton label="Borrar búsqueda" (click)="value.set('')">
          <ui-icon [icon]="clearIcon" size="1.125rem" />
        </button>
      }
    </div>
  `,
  styleUrl: './search-field.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFieldComponent {
  readonly label = input.required<string>();
  readonly placeholder = input<string>();
  readonly value = model('');
  readonly active = input(false, { transform: booleanAttribute });

  protected readonly inputId = `ui-search-${nextId++}`;
  protected readonly searchIcon = Search;
  protected readonly clearIcon = X;

  protected onInput(event: Event): void {
    this.value.set((event.target as HTMLInputElement).value);
  }
}
